module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/all_sports-f31b522e116b6e7eacb6c2d9d7764d0b.svg";